export default __webpack_public_path__ + "static/media/add-image.9e59830f.svg";